
if (window.location.href === 'https://www.gardenanswer.com/cart') {
    window.location.href = 'https://www.gardenanswer.com/?open_cart=true';
}



if (window.location.href.includes("/products/kneeling-pad")) {
  if (window.location.href.includes("?_pos")) {
    window.location.href = "https://www.gardenanswer.com/products/kneeling-pad";
  }
}

jQuery(document).ready(function ($) {
  var initialColor = $('.add-to-cart--color-button:first').val();
  $('.selected-color').text(initialColor);

  $('.add-to-cart--color-button').click(function () {
    var selectedColor = $(this).val();
    $('.selected-color').text(selectedColor);
  });



});


var _learnq = _learnq || [];

function logEventBasedOnURL() {
  if (window.location.href.indexOf('/blogs') !== -1) {
    var blogTitleElement = document.querySelector('.itemtitle');
    var blogTitle = blogTitleElement ? blogTitleElement.textContent.trim() : 'Unknown Title';

    _learnq.push(["track", "Viewed Blog", { title: blogTitle }]);
    console.log("viewed blog with title:", blogTitle);
  }
}

logEventBasedOnURL();






jQuery(document).ready(function($) {
    if ($('body').hasClass('article')) {
        function isMobile() {
            return window.innerWidth <= 768; 
        }

        if (isMobile()) {
            var $smallWrapper = $('.col.col-lg-9.col-xs-12');
            var $featuredProducts = $('.featured-products.wrapper.wrapper--small');

            $featuredProducts.insertAfter($smallWrapper);
        }
    }
});


document.addEventListener("DOMContentLoaded", function() {
    if (window.location.search.includes('open_cart=true')) {
        const cartButton = document.querySelector('.utility-menu--cart.flex.flex-column');
        if (cartButton) {
            cartButton.click();
        }
    }
});
